/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'dva';
import { useLocation, history } from 'umi';
import qs from 'qs';
import classnames from 'classnames';
import dayjs from 'dayjs';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
import ButtonML from '@/components/button_ml/ButtonML';
import ModalML from '@/components/modal_ml/ModalML';
import ActionBtnGroup from './components/action_group/ActionBtnGroup';
import IndexStyled from './IndexStyled.jsx';

const GoodsManagement = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchRef = useRef();
  const [isSearch, setIsSearch] = useState(false);
  const { query, pathname } = location;
  // 结构到所有查询条件，包括分页条件
  const {
    code,
    title,
    status,
    type,
    refreshTime,
    pageNum = '1',
    pageSize = '10',
  } = query;

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['giftManagement/getGoodsList'];
  const queryGiftPage = useSelector(
    (state) => state.giftManagement.queryGiftPage,
  );

  const [memberInfo, setMemberInfo] = useState({});

  const [column, setColumn] = useState();
  const [sort, setSort] = useState();

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        refreshTime: time,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };

  //选择多个table
  const onSelect = () => {
    // setIdArr(val);
  };

  // 获取礼品管理列表
  const fetchData = useCallback(() => {
    const values = {
      code,
      title,
      status,
      type,
      refreshTime,
      pageNum,
      pageSize,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'giftManagement/getQueryGiftPage',
      payload: {
        values,
      },
    });
  }, [dispatch, code, pageNum, pageSize, status, title, type, refreshTime]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  let { data: dataList, total } = queryGiftPage || {};

  return (
    <IndexStyled>
      <div
        data-log={JSON.stringify({
          oid: 'page_point_mall_gift_management_list',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        className="mm_content"
      >
        <div className={classnames('search_group', 'single_component1')}>
          <SearchGroup
            searchRef={searchRef}
            query={query}
            handleSearch={(par) => handleSearch(par)}
            restClick={handleRestClick}
          />
        </div>
        <ActionBtnGroup />
        <div className={classnames('table_page', 'single_component')}>
          {/* 默认使用loading包裹，使用tabel的loading会闪屏，且加载时tabel列头也加载 */}
          <TablePage
            pagination={{
              pageNum,
              pageSize,
            }}
            loading={loading}
            total={total}
            tableData={dataList}
            setPageData={handlePageChange}
            setColumn={(e) => setColumn(e)}
            setSort={(e) => setSort(e)}
          />
        </div>
      </div>
    </IndexStyled>
  );
};

export default GoodsManagement;
